var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0V0Z",
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_364_756",
    transform: "scale(0.0204082)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_364_756",
    width: 49,
    height: 49,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAAxCAYAAABznEEcAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAHASURBVHgB7ZjhUYNAEIUfGf+bVGCsQK3A2EE6kA4sIVpB0oHagakgpgLHCqSD0MG5K0cmIAcLxmPJ3DezyQC7sA/u9haAgA6iuoPGmDH9saVRFKUYEpT8jGxjivD2FEOAEo1NPffQDN9psl2DiJ0dZmoYlbYfkM2BOsbWTw1lEdeQIfXzwgjdUD2cEsiQ+vnHllYJV9AMJbhsELDAEOBEHaVVVVXKcbYdJludZ2QXyObAenCtR8AzEZRgh2/eNTMJDd9EEhuVTiRqKejkT44kmprDLcW+l2L4ejGqF1Ceg+z/RnGvkGAbwEYcsZI1ZmF9x2Qr044v43gV6Np2dMY+7Q3aN5FTsg+K/9W3eRdBPKN7A/lzA0zpVcC3iJhsjr/BApaHO3yLmOI4zA+fRh/D6RiwgH0l1CAiQVZG27Y0+3nVlwhO+JFsQvX/kuyObELbN5C/q8wq93pYJ3Ju4cDIPlYU8ujjSbzQXd+6DtpWYwUBpIM77H5ECHzWaEEfIj4FPglk8DzyLkL0Tdf6SKrVOf94F/EfvkNd7AoEEVoIIrQQRGghiNBCEKGFIEILJyHirGJfgm6kgtim4119Ayr4Bi+FJG06VkZMAAAAAElFTkSuQmCC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInImg);
export default __webpack_public_path__ + "static/media/inImg.9a4a5ce124c0f05f3ca268aed5f553a1.svg";
export { ForwardRef as ReactComponent };